import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-toolbar{height:100%}.monaco-toolbar .toolbar-toggle-more{display:inline-block;padding:0}";
n(css,{});
export { css, css as default };
